import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "divide-y" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-end px-6 py-3"
}
const _hoisted_3 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_4 = { class: "w-9/12" }
const _hoisted_5 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_6 = { class: "w-9/12" }
const _hoisted_7 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_8 = { class: "w-9/12" }
const _hoisted_9 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_10 = { class: "w-9/12" }
const _hoisted_11 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_12 = { class: "w-9/12" }
const _hoisted_13 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_14 = { class: "w-9/12" }
const _hoisted_15 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_16 = { class: "w-9/12" }
const _hoisted_17 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_18 = { class: "w-9/12" }
const _hoisted_19 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_20 = { class: "w-9/12" }
const _hoisted_21 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_22 = { class: "w-9/12" }
const _hoisted_23 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_24 = { class: "w-9/12" }
const _hoisted_25 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_26 = { class: "w-9/12" }
const _hoisted_27 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_28 = { class: "w-9/12" }
const _hoisted_29 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_30 = { class: "w-9/12" }
const _hoisted_31 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_32 = { class: "w-9/12" }
const _hoisted_33 = { class: "flex items-center p-6 space-x-6" }
const _hoisted_34 = { class: "w-9/12" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import ButtonComponent from "@/components/ButtonComponent.vue";
import { XMarkIcon } from "@heroicons/vue/24/solid";
import PageLoader from "@/components/PageLoader.vue";
import StatusPill from '@/components/StatusPill.vue';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import voucher from "@/classes/Voucher";
import { formatter } from '@/helpers/NumberHelper'
import { format, parseISO } from 'date-fns';
import { RequirementType } from '@/enums/RequirementType';
import { DiscountType } from '@/enums/DiscountType';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import DropdownData from '@/classes/DropdownData';
import { MaxUsageType } from '@/enums/MaxUsageType';
import { formatDateTime, formatDate } from '@/helpers/TimeFormatter'



export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route = useRoute();
const loader = ref(true);
const voucherData = ref(null);
const showConfirmation  = ref(false);
const showSuccess      = ref(false);
const packages = ref(false);
const riders = ref(false);
const patients = ref(false);

const fetchVoucherData = async () => {
    try {
        const voucherId = route.params.id as string;
        const response = await voucher.editVoucher(voucherId);
        voucherData.value = response.data.voucher;
        packages.value = response.data.packages;
        patients.value = response.data.patients;
        formatRiderOptions(response.data.riders);
    } catch (error) {
        console.error("Error fetching voucher data:", error);
    } finally {
        loader.value = false;
    }
};


const getSelectedNames = (ids: string[], data:any):string => {

    if(data){        
        const selectedValues = data.filter((item:any) => ids.includes(item.id));
        return  selectedValues.map((item:any) => item.name).join(", ");
    }

    return "--";
}

const formatRiderOptions = (data:any): void => {
    let options:any = [];

    data.forEach((rider:any) => {
        options = options.concat(
            rider.items.map((item) => {
                return {
                    id: item.item_id,
                    name: item.item_name
                }
            })
        )
    });

    riders.value = options;
}

const getRequirementType = (type: number) => {
    switch (type) {
        case RequirementType.AMOUNT:
        return 'Amount';
        case RequirementType.QUANTITY:
        return 'Quantity';
        default:
        return 'Unknown';
    }
}

const getDiscountType = (type: number) => {
    switch (type) {
        case DiscountType.FIXED:
        return 'Fixed';
        case DiscountType.PERCENTAGE:
        return 'Percentage';
        default:
        return 'Unknown';
    }
}


const getStatus = (status: number) => {
    let color = 'yellow';
    let text = 'Unknown';

    switch (status) {
        case 1:
            color = 'violet';
            text = 'Scheduled';
            break;
        case 2:
            color = 'yellow';
            text = 'Ongoing';
            break;
        case 3:
            color = 'red';
            text = 'Expired';
            break;
        case 4:
            color = 'red';
            text = 'Cancelled';
            break;
    }

    return { color, text };
}

const handleCancel = async () => {
    try {
        if (voucherData.value) {
            await voucher.cancelVoucher(voucherData.value.id);

            voucherData.value.status = 4; 
            
            showSuccess.value = true;
           
        }
    } catch (error) {
        console.error("Error cancelling voucher:", error);
        // Optionally, you can show an error message to the user
    }
};

onMounted(async () => {
    await fetchVoucherData();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Voucher",
    "show-back": "",
    backUrl: "/vouchers"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.$hasPermission('cancel-vouchers') && (voucherData.value?.status == 1 || voucherData.value?.status == 2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(ButtonComponent, {
                type: "button",
                color: "text-white bg-red-600 border-red-600",
                class: "h-10",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(XMarkIcon), { class: "w-5 h-5 mr-2" }),
                  _cache[5] || (_cache[5] = _createTextVNode(" Cancel ", -1))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-3/12" }, "Voucher No.", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(voucherData.value?.id), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-3/12" }, "Date Created", -1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formatDateTime)(voucherData.value?.created_at)), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-3/12" }, "Voucher Name", -1)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(voucherData.value?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "w-3/12" }, "Voucher Code", -1)),
          _createElementVNode("div", _hoisted_10, _toDisplayString(voucherData.value?.code), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "w-3/12" }, "Status", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(StatusPill, {
              color: getStatus(voucherData.value?.status).color,
              text: getStatus(voucherData.value?.status).text
            }, null, 8, ["color", "text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "w-3/12" }, "Participating Packages", -1)),
          _createElementVNode("div", _hoisted_14, [
            (voucherData.value?.packages.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(getSelectedNames(voucherData.value?.packages, packages.value)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" All ")
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "w-3/12" }, "Participating Riders", -1)),
          _createElementVNode("div", _hoisted_16, [
            (voucherData.value?.riders.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(getSelectedNames(voucherData.value?.riders, riders.value)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" All ")
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "w-3/12" }, "Participating Patients", -1)),
          _createElementVNode("div", _hoisted_18, [
            (voucherData.value?.patients.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(getSelectedNames(voucherData.value?.patients, patients.value)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" All ")
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "w-3/12" }, "Maximum Usage Count", -1)),
          _createElementVNode("div", _hoisted_20, [
            (voucherData.value?.max_usage_type == _unref(MaxUsageType).NONE)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" None ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(voucherData.value?.max_usage_count) + " (" + _toDisplayString(voucherData.value?.max_usage_count - voucherData.value?.usage_count) + " usages left) ", 1)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "w-3/12" }, "Requirement Type", -1)),
          _createElementVNode("div", _hoisted_22, _toDisplayString(getRequirementType(voucherData.value?.requirement_type)), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "w-3/12" }, "Requirement Value", -1)),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(formatter).format(voucherData.value?.requirement_value)), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "w-3/12" }, "Discount Type", -1)),
          _createElementVNode("div", _hoisted_26, _toDisplayString(getDiscountType(voucherData.value?.discount_type)), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "w-3/12" }, "Discount Value", -1)),
          _createElementVNode("div", _hoisted_28, [
            (voucherData.value?.discount_type == _unref(DiscountType).FIXED)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(formatter).format(voucherData.value?.discount_value)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(voucherData.value?.discount_value) + "% ", 1)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "w-3/12" }, "Start Date", -1)),
          _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(formatDateTime)(voucherData.value?.start_at, 'Asia/Manila', 'MMM dd, yyy HH:mm:ss')), 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "w-3/12" }, "End Date", -1)),
          _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(formatDateTime)(voucherData.value?.end_at, 'Asia/Manila', 'MMM dd, yyy HH:mm:ss')), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-3/12" }, "Description", -1)),
          _createElementVNode("div", _hoisted_34, _toDisplayString(voucherData.value?.description), 1)
        ])
      ]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => {showConfirmation.value = false; handleCancel() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Cancel Voucher ?",
        content: "Are you sure you wish to cancel this voucher?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Cancellation Successful",
        content: "Your voucher cancellation request has been completed"
      }, null, 8, ["show"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})